import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useSearchState } from '#src/app/pages/search/shared/searchState';

type Result = ModelHookResult<{
	selectedLocationFilterName: string;
	disabled: boolean;
	active: boolean;
}>;

export function useLocationMobileButton(): Result {
	const { translate } = useI18n();
	const state = useSearchState();

	const locationSelected = state.locationCities[0] || state.locationCountries[0] || '';

	const selectedLocationFilterName = useMemo(() => {
		if (locationSelected) {
			return locationSelected;
		}
		return translate('corgi.search.filters.location.title');
	}, [locationSelected, translate]);

	return {
		data: {
			selectedLocationFilterName,
			disabled: false,
			active: !!locationSelected,
		},
	};
}
